import styled from '@emotion/styled';
import { rem } from '@utils';

const Wrapper = styled.section<{ height: number; expanded: boolean }>(
  ({ expanded, height, theme }) => `
  border: 1px solid ${theme.palette.grey['200']};
  border-radius: 12px;
  color: ${theme.palette.common.black};
  margin-bottom: ${rem(40)};
  overflow: hidden;
  overflow: hidden;

  ${Arrow} {
    transform: rotate(${expanded ? 180 : 0}deg);
  }

  ${Content} {
    height: ${expanded ? rem(height) : 0};
    transition: height 350ms cubic-bezier(0.7, 0.13, 0.35, 1);
    will-change: height;
  }
`
);

const Header = styled.header(
  ({ theme }) => `
  color: ${theme.palette.common.black};
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: ${rem(8)};
  padding: ${rem(24)};
  user-select: none;
`
);

const Title = styled.h4`
  color: inherit;
  flex-grow: 1;
  font-size: ${rem(16)};
  font-weight: 600;
  line-height: ${rem(24)};
  margin: 0;
`;

const Arrow = styled.div`
  width: ${rem(24)};
  height: ${rem(24)};
  padding: ${rem(8)} ${rem(5.5)};

  .icon {
    display: block;
  }
`;

const Content = styled.div();

const Skeleton = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: ${rem(12)};
`;

const SkeletonItem = styled.div<{
  width?: `${number}%` | `${number}px`;
}>(
  ({ theme, width = '100%' }) => `
  background: ${theme.palette.grey['200']};
  border-radius: 20px;
  height: ${rem(12)};
  width: ${width};
`
);

const ContentInner = styled.div`
  padding: ${rem(8)} ${rem(24)} ${rem(24)};
`;

const ContentTitle = styled.h5`
  color: inherit;
  font-size: ${rem(16)};
  font-weight: 600;
  line-height: ${rem(24)};
  margin-bottom: ${rem(16)};
  margin-right: auto;
`;

const Separator = styled.hr`
  background: ${({ theme }) => theme.palette.grey['300']};
  border: none;
  height: 1px;
  margin: ${rem(32)} 0;
  width: 100%;
`;

const SummaryText = styled.p`
  line-height: ${rem(20)};
`;

const SummaryList = styled.ul`
  padding-left: ${rem(16)};
`;

const SummaryListItem = styled.li`
  line-height: ${rem(20)};

  &:not(:last-of-type) {
    margin-bottom: ${rem(16)};
  }
`;

export default {
  Arrow,
  Content,
  ContentInner,
  ContentTitle,
  Header,
  Skeleton,
  SkeletonItem,
  Separator,
  SummaryList,
  SummaryListItem,
  SummaryText,
  Title,
  Wrapper
};
